import gql from 'graphql-tag';

export default gql`
  fragment ReportRequest on ReportRequest {
    id
    report {
      name
    }
    request_status
    start_at
    end_at
    error_details
    report_url
    report_start
    report_end
  }
`;
